// extracted by mini-css-extract-plugin
module.exports = {"component":"movies_component_2YusD"};